import axios from '../../services/axiosConfig';

const campaignApplicationService = {
  /**
   * Submit a campaign application
   * @param {string} campaignAdvertisingId - The campaign advertising ID
   * @param {object} applicationData - The application data
   */
  submitApplication: async (campaignAdvertisingId, applicationData) => {
    try {
      const response = await axios.post(
        `/company/campaigns/${campaignAdvertisingId}/apply`,
        applicationData
      );
  
      return response; // 👈 return FULL axios response
    } catch (error) {
      console.error('Error submitting application:', error);
  
      throw error; // let caller decide how to show error
    }
  },

  /**
   * Get all applications for a campaign advertising (for company)
   * @param {string} campaignAdvertisingId - The campaign advertising ID
   */
  getApplications: async (campaignAdvertisingId) => {
    try {
      const response = await axios.get(
        `/company/campaigns/${campaignAdvertisingId}/applications`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching applications:', error);
      throw new Error(
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to fetch applications'
      );
    }
  },

  /**
   * Get all applications for a campaign (for company)
   * @param {string} campaignId - The campaign ID
   */
  getCampaignApplications: async (campaignId) => {
    try {
      const response = await axios.get(
        `/company/campaigns/${campaignId}/applications/all`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching campaign applications:', error);
      throw new Error(
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to fetch campaign applications'
      );
    }
  },

  /**
   * Check if user has applied to a campaign advertising
   * @param {string} campaignAdvertisingId - The campaign advertising ID
   */
  checkUserApplication: async (campaignAdvertisingId) => {
    try {
      const response = await axios.get(
        `/company/campaigns/${campaignAdvertisingId}/check-application`
      );
      return response.data;
    } catch (error) {
      // If 401, user is not logged in - return hasApplied: false
      if (error.response?.status === 401) {
        return { success: true, hasApplied: false, application: null };
      }
      console.error('Error checking user application:', error);
      // Return hasApplied: false on error to not block UI
      return { success: false, hasApplied: false, application: null };
    }
  },

  /**
   * Update application status
   * @param {string} applicationId - The application ID
   * @param {object} statusData - Status, notes, rejectionReason, and rejectionNotes
   */
  updateApplicationStatus: async (applicationId, statusData) => {
    try {
      const response = await axios.patch(
        `/company/campaigns/applications/${applicationId}/status`,
        statusData
      );
      return response.data;
    } catch (error) {
      console.error('Error updating application status:', error);
      throw new Error(
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to update application status'
      );
    }
  }
};

export default campaignApplicationService;

